export const favorites = {
  title: "Meus favoritos",
  subtitle: "{{count}} alojamentos salvos",
  countries: "Países",
  cities: "Cidades",
  emptyTitle: "Nenhum favorito por enquanto",
  emptyFiltered: "Tente modificar seus filtros para ver seus favoritos.",
  emptyState:
    "Explore nossos alojamentos únicos e adicione-os aos favoritos para encontrá-los aqui.",
  noFavoritesYet: "Nenhum favorito por enquanto",
  exploreMembersMap: "Explore o mapa de membros para encontrar alojamentos",
  exploreMap: "Explorar o mapa",
  backToHome: "Voltar ao início",
  howToAddFavorites: "Como adicionar favoritos?",
  step1: "Vá para a",
  step2: "mapa de membros",
  step3: "e clique no coração",
  step3End: "para adicionar um alojamento aos seus favoritos",
  membersMapLink: "Mapa de membros",
  properties: "propriedades",
  selected: "selecionadas",
  compare: "Comparar",
  actions: "Ações",
  contact: "Contatar",
  exchange: "Propor uma troca",
  removeFromFavorites: "Remover dos favoritos",
  removeFromComparison: "Remover da comparação",
  owner: "Proprietário",
  ratingLabel: "Nota",
  exchangesLabel: "Trocas",
  exchangesCount: "trocas",
  exchangesCompleted: "trocas realizadas",
  capacityLabel: "Capacidade",
  guestsCount: "viajantes",
  numberOfRooms: "quartos",
  roomsCount: "quartos",
  onlineStatus: "Conectado",
  onlineBadge: "Conectado",
  verifiedStatus: "Verificado",
  verifiedBadge: "Verificado",
  no: "Não",
};
